module.exports = __webpack_public_path__ + "img/government_quanzong.b6b0413f.png";